import { AdvantageCard } from "./AdvantageCard";

const PercentIcon = () => (
  <div className="w-[36px] h-[36px] flex items-center justify-center">
    <img
      src="/images/money_15512574 1.svg"
      alt=""
      className="w-[28px] h-[28px] object-contain"
      aria-hidden="true"
    />
  </div>
);

const PhoneIcon = () => (
  <div className="w-[36px] h-[36px] flex items-center justify-center">
    <img
      src="/images/Layer_x0020_1.svg"
      alt=""
      className="w-[28px] h-[28px] object-contain"
      aria-hidden="true"
    />
  </div>
);

const ChartIcon = () => (
  <div className="w-[36px] h-[36px] flex items-center justify-center">
    <img
      src="/images/Group 2085663690.svg"
      alt=""
      className="w-[28px] h-[28px] object-contain"
      aria-hidden="true"
    />
  </div>
);

const SparkleIcon = () => (
  <div className="w-[36px] h-[36px] flex items-center justify-center">
    <img
      src="/images/Group 2085663691.svg"
      alt=""
      className="w-[28px] h-[28px] object-contain"
      aria-hidden="true"
    />
  </div>
);

export const OurAdvantageSection = () => {
  return (
    <div>
      <div className="hidden lg:block px-6">
        <section className="w-full flex justify-center  pb-24 bg-[#FAFAFA]">
      <div className="w-full max-w-[1700px] px-6">
        <div className="flex items-center justify-center gap-3 text-[#2A2A2A]">
          <span className="w-[14px] h-[14px] rounded-full bg-[#D90000]" />
          <span className="text-[16px] leading-none font-medium">Our Advantage</span>
        </div>

        <h2 className="mt-6 text-center text-[#171717] text-[56px] leading-[1.1] font-medium tracking-[-1.4px]">
          Powerful Growth,
          <br />
           Zero Friction
        </h2>

        <p className="mt-5 text-center text-[#2B2B2B] text-[18px] leading-[1.45] max-w-[650px] mx-auto">
          Enterprise-grade marketing tools designed for busy local owners. No complex tech, no staff headaches.
        </p>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-4 items-stretch">
          <div className="rounded-[36px] overflow-hidden h-[450px] min-h-[548px] shadow-[0px_8px_28px_rgba(0,0,0,0.06)]">
            <img
              src="/images/Webp/Rectangle 34625690.webp"
              alt="Business using My Couponbook at checkout"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <AdvantageCard
              tinted
              icon={<PercentIcon />}
              title="Keep 100% of Revenue."
              description="Stop losing margins. Customers pay you directly—we don’t take a cut."
            />

            <AdvantageCard
              icon={<PhoneIcon />}
              title="Frictionless Redemption."
              description="No new hardware or staff training required. Customers redeem seamlessly on their own phones."
            />

            <AdvantageCard
              icon={<ChartIcon />}
              title="Real-Time ROI"
              description="Track views, follows, and redemptions instantly. Know exactly what's driving your growth."
            />

            <AdvantageCard
              icon={<SparkleIcon />}
              title="AI-Powered Marketing"
              description="Don't have time to write? Our AI generates perfect coupon headlines and terms in seconds."
            />
          </div>
        </div>
      </div>
    </section>
      </div>

      <div className="block lg:hidden">
        <section className="w-full flex justify-center  pb-24 bg-[#FAFAFA]">
      <div className="w-full max-w-[1700px] px-6">
        <div className="flex justify-center items-center gap-3 text-gray-600 mb-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span className="text-[16px]">Our Advantage</span>
        </div>
        

         {/* heading */}
        <h2 className="text-[30px] text-center text-gray-900 mb-4 leading-tight px-4">
         Powerful Growth, Zero Friction
          
        </h2>


        <p className="mt-5 text-center text-[#2B2B2B] text-[12px] leading-[1.45] max-w-[650px] mx-auto">
          Enterprise-grade marketing tools designed for busy local owners. No complex tech, no staff headaches.
        </p>

       <div className="mt-6 flex flex-col gap-4">
  <img
    src="/images/Webp/Rectangle 34625690.webp"
    alt="Business using My Couponbook at checkout"
    className="w-full h-[400px] object-cover rounded-[36px] shadow-[0px_8px_28px_rgba(0,0,0,0.06)]"
  />

  <div className="grid grid-cols-2 gap-4">
    <AdvantageCard
      tinted
      icon={<PercentIcon />}
      title="Keep 100% of Revenue."
      description="Stop losing margins. Customers pay you directly—we don't take a cut."
    />
    <AdvantageCard
      icon={<PhoneIcon />}
      title="Frictionless Redemption."
      description="No new hardware or staff training required. Customers redeem seamlessly on their own phones."
    />
    <AdvantageCard
      icon={<ChartIcon />}
      title="Real-Time ROI"
      description="Track views, follows, and redemptions instantly. Know exactly what's driving your growth."
    />
    <AdvantageCard
      icon={<SparkleIcon />}
      title="AI-Powered Marketing"
      description="Don't have time to write? Our AI generates perfect coupon headlines and terms in seconds."
    />
  </div>
</div>
      </div>
    </section>
      </div>
    </div>
    
  );
};